import { render } from "./ModalDocumentoEmAnalise.vue?vue&type=template&id=0dfdc399&scoped=true"
import script from "./ModalDocumentoEmAnalise.vue?vue&type=script&lang=js"
export * from "./ModalDocumentoEmAnalise.vue?vue&type=script&lang=js"

import "./ModalDocumentoEmAnalise.vue?vue&type=style&index=0&id=0dfdc399&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfdc399"]])

export default __exports__